module.exports = __webpack_public_path__ + "ee93cc6e4e94760339f27165a560edcc.jpeg";